<div>
  <label for="notes">ADDITIONAL DETAIL</label>
  @if (!showNotes) {
    <fa-icon
      class="toggle-button"
      [icon]="['fas', 'plus-square']"
      size="sm"
      (click)="onPlusClick()" />
  }
  @if (showNotes) {
    <fa-icon
      class="toggle-button"
      [icon]="['fas', 'minus-square']"
      size="sm"
      (click)="onMinusClick()" />
  }
  <textarea
    tabindex="-1"
    id="notes"
    name="notes"
    class="form-control"
    [hidden]="!showNotes"
    [disabled]="notesFrozen"
    (change)="onNotesChange()"
    [(ngModel)]="notes"
    rows="5">
  </textarea>
</div>
